var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(!_vm.isExternal && _vm.href ? 'router-link-component' : 'html-link-component',{tag:"component",attrs:{"href":_vm.href,"target":_vm.isExternal || _vm.newWindow ? '_blank' : '_self',"active-class":_vm.activeClass,"exact-active-class":_vm.exactActiveClass}},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64fbfe30","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../default-js/js/components/common/Link.vue
// module id = lwMF
// module chunks = 17